var App = App || {};

App.SharedSplide = (function () {
    'use strict';

    function setCarousel(carousel) {

        const splide = new Splide(carousel[0], {
            mediaQuery: 'min',
            arrows: true,
            pagination: false,
            type: 'loop',
            perMove: 1,
            focus: 'center',
            fixedWidth: '60%',
            breakpoints: {
                768: {
                    focus: 1,
                    fixedWidth: '25%',
                }
            }
        });

        splide.mount();
    }

    return {
        setCarousel: setCarousel
    };

})();